import { render } from "./SkinProfileIcon.vue?vue&type=template&id=10965d4b&scoped=true&bindings={}"
import script from "./SkinProfileIcon.vue?vue&type=script&lang=ts"
export * from "./SkinProfileIcon.vue?vue&type=script&lang=ts"

import "./SkinProfileIcon.vue?vue&type=style&index=0&id=10965d4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10965d4b"

export default script